import { apiEndpoints } from '@/apiEndpoints';
import { Project } from '@/types/projects/projectsColumnDef';
import { DistributorParams } from './distributor.api';
import axios from 'axios';
import { ProjectFormData } from '@/types/projects/ProjectFormData';
import { ProjectResponse } from '@/types/projects/ProjectResponse';

export type getProjectsParams = Omit<DistributorParams, 'filters'>;

export type ProjectsResponse = {
  projects: Project[];
  total: number;
};

export const getProjects = async (
  clientId: string,
  params: getProjectsParams,
) => {
  const result = await axios.get<ProjectsResponse>(
    apiEndpoints.projects.byClient(clientId),
    { params },
  );

  return result.data;
};

export const createProject = async (
  clientId: string,
  projectData: ProjectFormData,
) => {
  return axios.post(apiEndpoints.projects.create(clientId), projectData);
};

export type UpdateParticipantDto = Partial<
  ProjectFormData['adults'][number]
> & {
  id?: string;
};

export type UpdateProjectDto = Partial<
  Omit<ProjectFormData, 'adults' | 'children'>
> & {
  adults?: UpdateParticipantDto[];
  children?: UpdateParticipantDto[];
};

export const updateProject = async (
  clientId: string,
  projectId: string,
  projectData: UpdateProjectDto,
) => {
  return axios.put(
    apiEndpoints.projects.update(clientId, projectId),
    projectData,
  );
};

export const findProject = async (clientId: string, projectId: string) => {
  const result = await axios.get<ProjectResponse>(
    apiEndpoints.projects.detail(clientId, projectId),
  );
  return result.data;
};

export const deleteProject = async (clientId: string, projectId: string) => {
  return axios.delete(apiEndpoints.projects.delete(clientId, projectId));
};
